namespace RioERP.Products {
    export namespace ProductSpecificationsBooksService {
        export const baseUrl = 'Products/ProductSpecificationsBooks';

        export declare function Create(request: Serenity.SaveRequest<ProductSpecificationsBooksRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ProductSpecificationsBooksRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ProductSpecificationsBooksRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ProductSpecificationsBooksRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Products/ProductSpecificationsBooks/Create",
            Update = "Products/ProductSpecificationsBooks/Update",
            Delete = "Products/ProductSpecificationsBooks/Delete",
            Retrieve = "Products/ProductSpecificationsBooks/Retrieve",
            List = "Products/ProductSpecificationsBooks/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ProductSpecificationsBooksService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
